import Link from "next/link";
import styles from './ua.module.scss'
import { URL_MAPPINGS } from "@/utils/Actions";
import { emitEvent } from "../plugins/EventListener";
import ClientButton from "./ClientButton";

export default function Button(props) {

  const isHref = props.href || (props.mapping && URL_MAPPINGS[props.mapping] != "function") ? true : false
  const href = isHref ? props.href || URL_MAPPINGS[props.mapping] : null
  
  const onTap = (e) => {
    e.preventDefault()
    if (props.onPress) {
      props.onPress(e)
    } else if (props.onClick) {
      props.onClick(e)
    } else if (props.mapping) {
      if (props.mapping == "lead-form") {
        emitEvent("show_lead_form_slide", { ref: props.data })
      } else if (props.mapping == "trade-form") {
        emitEvent("show_trade_slide", { ref: props.data })
      } else if (props.mapping == "favorites") {
        emitEvent("show_favorites_slide", { ref: props.data })
      } else if (props.mapping == "show-by-budget") {
        emitEvent("shop_by_budget", { ref: props.data })
      }
    }
  }
  
  const theme = () => {
    if (!props.theme || props.plain || props.theme == "none") return ""
    let s = [ styles.base ]
    if (Array.isArray(props.theme)) {
      props.theme.map(t => {
        s.push(styles[t])
      })
    } else {
      s.push(styles[props.theme])
    }
    return s.join(" ")
  }
  
  const cleanUrl = (url) => {
    // if (url.indexOf("tel:") == 0) return url
    // if (url.indexOf("/") == 0) return url
    // if (url.indexOf("#") == 0) return url
    // if (url.indexOf("http") != 0) return "https://" + url
    return url
  }

  const render = () => {
    if (props.displayOnly) {
      return <div id={props.id} className={ theme() + ' ' + props.className } style={ props.style || {}} target={props.target} href={ href }>
        { props.children || props.label }
        { props.badge &&
        <span className={styles.badge}></span>
        }
      </div>
    }
    if (href) {
      return (
        <Link id={props.id} className={ theme() + ' ' + props.className } style={ props.style || {}} target={props.target} href={ cleanUrl(href) } tabIndex={0} aria-label={props.label} prefetch={false}>
          { props.children || props.label }
          { props.badge &&
          <span className={styles.badge}></span>
          }
        </Link>
      )
    } else if (props.onPress || props.onClick || props.mapping) {
      return <button id={props.id} mapping={props.mapping} className={ theme() + (props.className ? ' ' + props.className : '') } style={ props.style || {}} onClick={e => onTap(e)} tabIndex={0} aria-label={props.label} disabled={props.disabled}>
        { props.children || (props.noLabel ? '' : props.label) }
        { props.badge &&
        <span className={styles.badge}></span>
        }
      </button>
    } else {
      return <button id={props.id} type="submit" className={ theme() + (props.className ? ' ' + props.className : '') } style={ props.style || {}} aria-label={props.label} tabIndex="0" disabled={props.disabled}>
        { props.children || (props.noLabel ? '' : props.label) }
        { props.badge &&
        <span className={styles.badge}></span>
        }
      </button>
    }
  }

  if (href || props.client) {
    return render()
  } else {
    return <ClientButton {...props}></ClientButton>
  }
   
}